import { Routes, Route } from 'react-router-dom';

import DistribuidoresIndex from "../Forms/Distribuidores/DistribuidoresIndex";
import UsuariosIndex from "../Forms/Usuarios/UsuariosIndex";
import NovoUsuario from "../Forms/Usuarios/NovoUsuario";
import EditarUsuario from "../Forms/Usuarios/EditarUsuario";
import NovoDistribuidor from "../Forms/Distribuidores/NovoDistribuidor";
import EditarDistribuidor from "../Forms/Distribuidores/EditarDistribuidor";
import DistribuidorClientes from "../Forms/Distribuidores/DistribuidorClientes";
import ClientesIndex from "../Forms/Clientes/ClientesIndex";
import NovoCliente from "../Forms/Clientes/NovoCliente";
import EditarCliente from "../Forms/Clientes/EditarCliente";
import ClientesCnpjIndex from "../Forms/Clientes/ClientesCnpjIndex";
import BmaPontoIndex from "../Forms/BmaPonto/BmaPontoIndex";
import NovoPedidoBmaPonto from "../Forms/BmaPonto/NovoPedidoBmaPonto";
import EditarPedidoBmaPonto from "../Forms/BmaPonto/EditarPedidoBmaPonto";
import ViewPedidoBmaPonto from "../Forms/BmaPonto/ViewPedidoBmaPonto";
import CancelarPedidoBmaPonto from "../Forms/BmaPonto/CancelarPedidoBmaPonto";
import BmaAcessoIndex from "../Forms/BmaAcesso/BmaAcessoIndex";
import NovoPedidoBmaAcesso from "../Forms/BmaAcesso/NovoPedidoBmaAcesso";
import EditarPedidoBmaAcesso from "../Forms/BmaAcesso/EditarPedidoBmaAcesso";
import ViewPedidoBmaAcesso from "../Forms/BmaAcesso/ViewPedidoBmaAcesso";
import CancelarPedidoBmaAcesso from "../Forms/BmaAcesso/CancelarPedidoBmaAcesso";
import BmaFolhaIndex from "../Forms/BmaFolha/BmaFolhaIndex";
import NovoPedidoBmaFolha from "../Forms/BmaFolha/NovoPedidoBmaFolha";
import EditarPedidoBmaFolha from "../Forms/BmaFolha/EditarPedidoBmaFolha";
import ViewPedidoBmaFolha from "../Forms/BmaFolha/ViewPedidoBmaFolha";
import CancelarPedidoBmaFolha from "../Forms/BmaFolha/CancelarPedidoBmaFolha";
import ContratosIndex from "../Forms/Contratos/ContratosIndex";
import NovoContrato from "../Forms/Contratos/NovoContrato";
import EditarContrato from "../Forms/Contratos/EditarContrato";
import CancelarContrato from "../Forms/Contratos/CancelarContrato";
import ViewContrato from "../Forms/Contratos/ViewContrato";
import ServicosIndex from "../Forms/Servicos/ServicosIndex";
import NovoServico from "../Forms/Servicos/NovoServico";
import EditarServico from "../Forms/Servicos/EditarServico";
import ViewServico from "../Forms/Servicos/ViewServico";
import CancelarServico from "../Forms/Servicos/CancelarServico";
import GeracaoFaturamento from "../Forms/Faturamento/GeracaoFaturamento";
import RelatorioFaturamento from "../Forms/Faturamento/RelatorioFaturamento";
import RelatorioParcialFaturamento from "../Forms/Faturamento/RelatorioParcialFaturamento";
import RelatorioParcialFaturamentoRevenda from "../Forms/Faturamento/RelatorioParcialFaturamentoRevenda";
import RelatorioPedidosOSFaturadas from "../Forms/Faturamento/RelatorioPedidosOSFaturadas";
import { RelatorioDesempenhoRevenda } from '../Forms/Graficos/RelatorioDesempenhoRevenda/RelatorioDesempenhoRevenda';
import PersonalizacaoPontoIndex from "../Forms/Personalizacoes/BmaPonto/PersonalizacaoPontoIndex";
import EditarPersonalizacaoPonto from "../Forms/Personalizacoes/BmaPonto/EditarPersonalizacaoPonto";
import ViewPersonalizacaoPonto from "../Forms/Personalizacoes/BmaPonto/ViewPersonalizacaoPonto";
import PersonalizacaoAcessoIndex from "../Forms/Personalizacoes/BmaAcesso/PersonalizacaoAcessoIndex";
import EditarPersonalizacaoAcesso from "../Forms/Personalizacoes/BmaAcesso/EditarPersonalizacaoAcesso";
import ViewPersonalizacaoAcesso from "../Forms/Personalizacoes/BmaAcesso/ViewPersonalizacaoAcesso";
import PersonalizacaoFolhaIndex from "../Forms/Personalizacoes/BmaFolha/PersonalizacaoFolhaIndex";
import EditarPersonalizacaoFolha from "../Forms/Personalizacoes/BmaFolha/EditarPersonalizacaoFolha";
import ViewPersonalizacaoFolha from "../Forms/Personalizacoes/BmaFolha/ViewPersonalizacaoFolha";
import GraficosIniciais from "../Forms/Graficos/GraficosIniciais";
import VersoesIndex from "../Forms/Versoes/VersoesIndex";
import NovaVersao from "../Forms/Versoes/NovaVersao";
import ClienteVersoes from "../Forms/Versoes/ClienteVersoes";
import Dashboard from "../Forms/Graficos/Dashboard";
import ConsultaClientes from "../Forms/Clientes/ConsultaClientes";
import EditarClienteGlobal from "../Forms/Clientes/EditarClienteGlobal";
import ConsultaPorTipoPlanoOuVertical from "../Forms/Personalizacoes/Consultas/ConsultaPorTipoPlanoOuVertical";
import Login from "../Forms/Login/Login";
import Home from '../Forms/Home/Home';
import { ContratosCancelados } from '../Forms/Contratos/Relatorios/ContratosCancelados';
import { ProtectedRoute } from './ProtectedRoute';

export function Router() {
    return (
        <Routes>    
            <Route path="login" element={ <Login /> }/>
            <Route element={<ProtectedRoute />}>
                <Route path='/' element={<Home />}/>
                <Route path="usuarios" element={ <UsuariosIndex />}/>

                <Route path="distribuidores" element={ <DistribuidoresIndex />}/>           
                <Route path="distribuidorclientes/:id" element={<DistribuidorClientes />}/>

                <Route path="clientes" element={<ClientesIndex />}/>
                <Route path="clientecnpj/:id" element={<ClientesCnpjIndex />}/>

                <Route path="pedidosponto" element={<BmaPontoIndex />}/>
                <Route path="viewpedidobmaponto/:id" element={<ViewPedidoBmaPonto />}/>

                <Route path="pedidosacesso" element={<BmaAcessoIndex />} />
                <Route path="viewpedidobmaacesso/:id" element={<ViewPedidoBmaAcesso />}/>

                <Route path="pedidosfolha" element={<BmaFolhaIndex />}/>
                <Route path="viewpedidobmafolha/:id" element={<ViewPedidoBmaFolha />}/>

                <Route path="contratos" element={<ContratosIndex />}/>
                <Route path="viewcontrato/:id" element={<ViewContrato />}/>

                <Route path="servicos" element={<ServicosIndex />}/>
                <Route path="viewservico/:id" element={<ViewServico />}/>

                <Route path="geracaofaturamento" element={<GeracaoFaturamento />}/>
                <Route path="relatoriopedidos" element={<RelatorioPedidosOSFaturadas />}/>
                <Route path="relatoriofaturamento" element={<RelatorioFaturamento />}/>
                <Route path="relatorioparcialfaturamentorevenda" element={<RelatorioParcialFaturamentoRevenda />}/>
                <Route path="relatorioparcialfaturamento" element={<RelatorioParcialFaturamento />}/>
                <Route path="desempenho" element={<RelatorioDesempenhoRevenda />}/>
                <Route path="contratoscancelados" element={<ContratosCancelados />}/>

                <Route path="personalizacoesponto" element={<PersonalizacaoPontoIndex />}/>
                <Route path="viewpersonalizacaoponto/:id" element={<ViewPersonalizacaoPonto />}/>

                <Route path="personalizacoesacesso" element={<PersonalizacaoAcessoIndex />}/>
                <Route path="viewpersonalizacaoacesso/:id" element={<ViewPersonalizacaoAcesso />}/>

                <Route path="clienteversoes" element={<ClienteVersoes />}/>
                <Route path="personalizacoesplanovertical" element={<ConsultaPorTipoPlanoOuVertical />}/>

                <Route path="personalizacoesfolha" element={<PersonalizacaoFolhaIndex />}/>
                <Route path="viewpersonalizacaofolha/:id" element={<ViewPersonalizacaoFolha />}/>

                <Route path="graficosiniciais" element={<GraficosIniciais />}/>
                <Route path="dashboard" element={<Dashboard />}/>
                
                <Route path="versoes" element={<VersoesIndex />}/>

                <Route path="consultaclientes" element={<ConsultaClientes />}/>
            </Route>
            
            <Route element={<ProtectedRoute changes={true} />}>
                <Route path="novousuario" element={<NovoUsuario />} />
                <Route path="editarusuario/:id" element={<EditarUsuario />}/>

                <Route path="novodistribuidor" element={<NovoDistribuidor />}/>
                <Route path="editardistribuidor/:id" element={<EditarDistribuidor />}/>

                <Route path="novocliente" element={<NovoCliente />}/>
                <Route path="editarcliente/:id" element={<EditarCliente />}/>

                <Route path="novopedidobmaponto" element={<NovoPedidoBmaPonto />}/>
                <Route path="editarpedidobmaponto/:id" element={<EditarPedidoBmaPonto />}/>
                <Route path="cancelarpedidobmaponto/:id" element={<CancelarPedidoBmaPonto />}/>

                <Route path="novopedidobmaacesso" element={<NovoPedidoBmaAcesso />}/>
                <Route path="editarpedidobmaacesso/:id" element={<EditarPedidoBmaAcesso />}/>
                <Route path="cancelarpedidobmaacesso/:id" element={<CancelarPedidoBmaAcesso />}/>

                <Route path="novopedidobmafolha" element={<NovoPedidoBmaFolha />}/>
                <Route path="editarpedidobmafolha/:id" element={<EditarPedidoBmaFolha />}/>
                <Route path="cancelarpedidobmafolha/:id" element={<CancelarPedidoBmaFolha />}/>

                <Route path="novocontrato" element={<NovoContrato />}/>
                <Route path="editarcontrato/:id" element={<EditarContrato />}/>
                <Route path="cancelarcontrato/:id" element={<CancelarContrato />}/>

                <Route path="novoservico" element={<NovoServico />}/>
                <Route path="editarservico/:id" element={<EditarServico />}/>
                <Route path="cancelarservico/:id" element={<CancelarServico />}/>

                <Route path="editarpersonalizacaoponto/:id" element={<EditarPersonalizacaoPonto />}/>

                <Route path="editarpersonalizacaoacesso/:id" element={<EditarPersonalizacaoAcesso />}/>

                <Route path="editarpersonalizacaofolha/:id" element={<EditarPersonalizacaoFolha />}/>

                <Route path="novaversao" element={<NovaVersao /> } />

                <Route path="editarclienteglobal/:id" element={<EditarClienteGlobal />}/>
            </Route>
        </Routes>       
    )
}